(() => {
  if (window.__nllProductImagesReady) return;
  window.__nllProductImagesReady = true;
  const size = 240;
  const process = async (img) => {
    if (img.dataset.nllNormalized) return;
    img.dataset.nllNormalized = 'pending';
    try {
      const source = new Image();
      source.crossOrigin = 'anonymous';
      source.src = img.currentSrc || img.src;
      await source.decode();
      const sample = document.createElement('canvas');
      sample.width = size; sample.height = size;
      const ctx = sample.getContext('2d', { willReadFrequently: true });
      ctx.fillStyle = '#fff'; ctx.fillRect(0, 0, size, size);
      const fit = Math.min(size / source.naturalWidth, size / source.naturalHeight);
      const sw = source.naturalWidth * fit, sh = source.naturalHeight * fit;
      ctx.drawImage(source, (size-sw)/2, (size-sh)/2, sw, sh);
      const pixels = ctx.getImageData(0, 0, size, size).data;
      let left=size, top=size, right=-1, bottom=-1;
      for (let y=0; y<size; y+=2) for (let x=0; x<size; x+=2) {
        const i=(y*size+x)*4;
        if (pixels[i]<238 || pixels[i+1]<238 || pixels[i+2]<238) {
          left=Math.min(left,x); right=Math.max(right,x);
          top=Math.min(top,y); bottom=Math.max(bottom,y);
        }
      }
      if (right<left || bottom<top) throw new Error('No product pixels');
      const w=right-left+1, h=bottom-top+1;
      const pad=Math.max(4,Math.round(Math.max(w,h)*.04));
      left=Math.max(0,left-pad); top=Math.max(0,top-pad);
      right=Math.min(size,right+pad); bottom=Math.min(size,bottom+pad);
      const cropW=right-left, cropH=bottom-top;
      const target=document.createElement('canvas'); target.width=640; target.height=640;
      const out=target.getContext('2d');
      out.fillStyle='#fff'; out.fillRect(0,0,640,640);
      const scale=552/Math.max(cropW,cropH), outW=cropW*scale, outH=cropH*scale;
      const sourceX=Math.max(0,(left-(size-sw)/2)/fit), sourceY=Math.max(0,(top-(size-sh)/2)/fit);
      const sourceW=Math.min(source.naturalWidth-sourceX,cropW/fit), sourceH=Math.min(source.naturalHeight-sourceY,cropH/fit);
      out.drawImage(source,sourceX,sourceY,sourceW,sourceH,(640-outW)/2,(640-outH)/2,outW,outH);
      if(img.closest('.nll-pack-images,.nll-quick-link-products')){
        const data=out.getImageData(0,0,640,640),rgba=data.data;
        const seen=new Uint8Array(640*640),queue=new Uint32Array(640*640);let head=0,tail=0;
        const add=(p)=>{if(p<0||p>=seen.length||seen[p])return;seen[p]=1;const i=p*4;if(rgba[i]>237&&rgba[i+1]>237&&rgba[i+2]>237){queue[tail++]=p;rgba[i+3]=0;}};
        for(let n=0;n<640;n++){add(n);add(639*640+n);add(n*640);add(n*640+639);}
        while(head<tail){const p=queue[head++],x=p%640;if(x>0)add(p-1);if(x<639)add(p+1);add(p-640);add(p+640);}
        out.putImageData(data,0,0);
      }
      img.removeAttribute('srcset'); img.removeAttribute('sizes');
      img.src=target.toDataURL('image/webp',.92);
      img.dataset.nllNormalized='yes';
    } catch (_) { img.dataset.nllNormalized='fallback'; }
  };
  const observer=new IntersectionObserver(entries => {
    for (const entry of entries) if (entry.isIntersecting) {
      observer.unobserve(entry.target);
      process(entry.target);
    }
  }, {rootMargin:'300px'});
  const scan=() => document.querySelectorAll('img[data-nll-product-image]:not([data-nll-normalized]),.nll-pack-images img:not([data-nll-normalized]),.nll-quick-link-products img:not([data-nll-normalized])').forEach(img=>observer.observe(img));
  if (document.readyState==='loading') document.addEventListener('DOMContentLoaded',scan,{once:true});
  else scan();
  document.addEventListener('toggle',scan,true);document.addEventListener('nll:package-images',scan);
  new MutationObserver(scan).observe(document.documentElement,{childList:true,subtree:true});
})();